import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_10 = { class: "control-label col-sm-6" }
const _hoisted_11 = { class: "col-sm" }
const _hoisted_12 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_13 = { class: "control-label col-sm-6" }
const _hoisted_14 = { class: "col-sm" }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_17 = { class: "control-label col-sm-6" }
const _hoisted_18 = { class: "col-sm" }

import { watch , ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo'
import FormFamigliaHelper from "../../pages/preventivi/json/famiglia/helper.json";
import FormImmobiliareHelper from "../../pages/preventivi/json/immobiliare/helper.json";
import DettaglioPreventivoHelper from "./../../pages/preventivi/json/dettagliopreventivo/helper.json";
import RegimeFiscale from "./RegimeFiscale.vue";
import AliquoteContributiRepertoriali from "./AliquoteContributiRepertoriali.vue";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";

export default {
  __name: 'FormFamigliaSeparazione',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo()
const props = __props
const emits = __emit
const { regimeFiscale } = inject('regimeFiscale')
let validazione;
const validazioneEquoCompenso = ref();
let indexHelperClosing;
const testoInfoCompilazione = ref([]);
switch (props.formName) {
  case 'separazioneDeiBeni':
    validazione = categorieValidazione.categoriaFamiglia['sottocategoriaSeparazione']['separazioneDeiBeni'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaFamiglia['sottocategoriaSeparazione']['separazioneDeiBeni'];
    testoInfoCompilazione.value =  FormFamigliaHelper.sottocategoriaSeparazione[props.formName];
    indexHelperClosing = {
      calcolo:   FormFamigliaHelper.sottocategoriaSeparazione[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    }
    break
  case 'comunioneDeiBeni':
    validazione = categorieValidazione.categoriaFamiglia['sottocategoriaSeparazione']['comunioneDeiBeni'];
    validazioneEquoCompenso.value = categorieValidazione.categoriaFamiglia['sottocategoriaSeparazione']['comunioneDeiBeni'];
    testoInfoCompilazione.value =  FormFamigliaHelper.sottocategoriaSeparazione[props.formName];
    indexHelperClosing = {
      calcolo:   FormFamigliaHelper.sottocategoriaSeparazione[props.formName],
      dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
    }
    break
  case 'trasferimentoImmobiliarePerSentenza':
    if(props.tipoPreventivo.data.categoria === 'categoriaImmobiliare'){
      validazioneEquoCompenso.value = categorieValidazione.categoriaImmobiliare['sottocategoriaTrasferimentiAlConiuge']['trasferimentoImmobiliarePerSentenza'];
      validazione = categorieValidazione.categoriaImmobiliare['sottocategoriaTrasferimentiAlConiuge']['trasferimentoImmobiliarePerSentenza'];
      indexHelperClosing = {
        calcolo:   FormImmobiliareHelper.sottocategoriaTrasferimentiAlConiuge[props.formName],
        dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
      }
      testoInfoCompilazione.value =  FormImmobiliareHelper.sottocategoriaTrasferimentiAlConiuge[props.formName];
    } else {
      validazione = categorieValidazione.categoriaFamiglia['sottocategoriaSeparazione']['trasferimentoImmobiliarePerSentenza'];
      validazioneEquoCompenso.value = categorieValidazione.categoriaFamiglia['sottocategoriaSeparazione']['trasferimentoImmobiliarePerSentenza'];
      indexHelperClosing = {
        calcolo:   FormFamigliaHelper.sottocategoriaSeparazione[props.formName],
        dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
      }
      testoInfoCompilazione.value =  FormFamigliaHelper.sottocategoriaSeparazione[props.formName];
    }

    break
}
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if (validazione) {
  validazione.tipo_preventivo.value = props.tipoPreventivo.data.categoria === 'categoriaImmobiliare' ? 'immobiliare/trasferimenti_al_coniuge/' + props.tipoPreventivo.data.url : 'famiglia/separazione/' + props.tipoPreventivo.data.url
}
function tipo (event) {
  if (event.target.value === 'con_immobili') {
    validazione.numero_conservatorie.value = '1'
    validazione.numero_conservatorie.required = true
  } else {
    validazione.numero_conservatorie.value = '0'
    validazione.numero_conservatorie.required = false
  }
}
watch(validazione, () => {
  emits('changeDatiPreventivo')
}, { deep: true })

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_select = _resolveComponent("base-select")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'separazioneDeiBeni')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).tipo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_select, {
                name: "tipo",
                options: [{name: 'Senza immobili', value: 'senza_immobili'},
            {name: 'Con immobili', value: 'con_immobili'}
            ],
                onChange: _cache[0] || (_cache[0] = $event => (tipo($event))),
                isSelected: _unref(validazione).tipo.value !== '',
                state: __props.readonly === true ?'disable':'',
                validateTo: _unref(validazione).tipo,
                "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).tipo) = $event))
              }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
            ])
          ]),
          (_unref(validazione).tipo.value === 'con_immobili')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_input_text, {
                    id: "numero_conservatorie",
                    name: "numero_conservatorie",
                    class: "placeholder-right crm:text-right",
                    placeholder: "Indicare numero conservatorie",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).numero_conservatorie,
                    "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly,
            "filter-options-d": true
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : (__props.formName === 'comunioneDeiBeni')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_10, [
                _createTextVNode(_toDisplayString(_unref(validazione).tipo.label), 1 /* TEXT */)
              ])), [
                [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.tipo.ref]
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_base_select, {
                  name: "tipo",
                  options: [{name: 'Senza immobili', value: 'senza_immobili'},
            {name: 'Con immobili', value: 'con_immobili'}
            ],
                  onChange: _cache[3] || (_cache[3] = $event => (tipo($event))),
                  isSelected: _unref(validazione).tipo.value !== '',
                  state: __props.readonly === true ?'disable':'',
                  validateTo: _unref(validazione).tipo,
                  "onUpdate:validateTo": _cache[4] || (_cache[4] = $event => ((_unref(validazione).tipo) = $event))
                }, null, 8 /* PROPS */, ["isSelected", "state", "validateTo"])
              ])
            ]),
            (_unref(validazione).tipo.value === 'con_immobili')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_13, [
                    _createTextVNode(_toDisplayString(_unref(validazione).numero_conservatorie.label), 1 /* TEXT */)
                  ])), [
                    [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_conservatorie.ref]
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_base_input_text, {
                      id: "numero_conservatorie",
                      name: "numero_conservatorie",
                      class: "placeholder-right crm:text-right",
                      placeholder: "Indicare numero conservatorie",
                      disabled: __props.readonly,
                      "validate-to": _unref(validazione).numero_conservatorie,
                      "onUpdate:validateTo": _cache[5] || (_cache[5] = $event => ((_unref(validazione).numero_conservatorie) = $event))
                    }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(RegimeFiscale, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(AliquoteContributiRepertoriali, {
              validazione: _unref(validazione),
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
            _createVNode(CalcoloEquoCompenso, {
              "input-riferimento-calcolo": "",
              validazione: validazioneEquoCompenso.value,
              helper: _unref(indexHelperClosing),
              readonly: __props.readonly,
              "filter-options-d": true
            }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
          ]))
        : (__props.formName === 'trasferimentoImmobiliarePerSentenza')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_17, [
                  _createTextVNode(_toDisplayString(_unref(validazione).valore.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.valore.ref]
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_base_input_text, {
                    id: "valore",
                    name: "valore",
                    class: "placeholder-right crm:text-right",
                    placeholder: "0,00",
                    disabled: __props.readonly,
                    "validate-to": _unref(validazione).valore,
                    "onUpdate:validateTo": _cache[6] || (_cache[6] = $event => ((_unref(validazione).valore) = $event))
                  }, null, 8 /* PROPS */, ["disabled", "validate-to"])
                ])
              ]),
              _createVNode(RegimeFiscale, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(AliquoteContributiRepertoriali, {
                validazione: _unref(validazione),
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
              _createVNode(CalcoloEquoCompenso, {
                "input-riferimento-calcolo": "",
                validazione: validazioneEquoCompenso.value,
                helper: _unref(indexHelperClosing),
                readonly: __props.readonly,
                "filter-options-d": true
              }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
            ]))
          : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}